import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_4,
  ANALYTICS_COLOR_FACEBOOK,
  ANALYTICS_COLOR_POSTS,
  FACEBOOK
} from '../../../config/constants';
import {
  METRIC_FACEBOOK_IMAGE_POST_COMMENT_COUNT,
  METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS,
  METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_ORGANIC,
  METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_PAID,
  METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_UNIQUE,
  METRIC_FACEBOOK_IMAGE_POST_SHARES,
  METRIC_FACEBOOK_PAGE_FANS,
  METRIC_FACEBOOK_PAGE_IMPRESSIONS,
  METRIC_FACEBOOK_PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_ANGER_TOTAL,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_HAHA_TOTAL,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_LIKE_TOTAL,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_LOVE_TOTAL,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_SORRY_TOTAL,
  METRIC_FACEBOOK_VIDEO_POST_REACTIONS_WOW_TOTAL,
  METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_TOTAL_IMPRESSIONS_ORGANIC,
  METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS,
  METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_PAID,
  METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_UNIQUE
} from '../../../config/metrics';
import * as icons from '../../../config/icons';
import { getStaticDataPoints } from '../../../utils/demoDataUtils/demoDataFunctions';
import {
  DEMO_DATA_FACEBOOK_ENGAGEMENET_REATIONS,
  DEMO_DATA_FACEBOOK_GROWTH_FOLLWERS,
  DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS,
  DEMO_DATA_FACEBOOK_GROWTH_REACTIONS,
  DEMO_DATA_FACEBOOK_OVERVIEW_IMPRESSION,
  DEMO_DATA_FACEBOOK_OVERVIEW_INTERACTION,
  DEMO_DATA_FACEBOOK_OVERVIEW_REACH,
  DEMO_DATA_FACEBOOK_POST_IMPRESSIONS,
  DEMO_DATA_FACEBOOK_VIDEO_IMPRESSIONS
} from '../../../utils/demoDataUtils/demoDataArrays';
import { displayFunctions } from '../../../utils/chartsUtils';

const filters = {
  filters: []
};
export const config: any = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_FACEBOOK_PAGE_IMPRESSIONS],
      title: 'organic',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      platform: FACEBOOK
      // formula: 'delta'
    }
  ]
};

export const facebookFanDevelopmentConfig: any = {
  shouldBeCached: false,
  ...filters,
  no_data_available: 'no_data_available',
  metrics: [
    {
      metrics: [METRIC_FACEBOOK_PAGE_FANS],
      title: 'followers',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'max',
      platform: FACEBOOK
    }
  ]
};

export const facebookGrowthConfig: any = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'Posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar',
  //     platform: FACEBOOK
  // },

  metrics: [
    {
      metrics: [71, 72, 73, 74, 75, 76, 120, 121, 122, 123, 124, 125],
      title: 'reactions',
      iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_REACTIONS
        }
      }
      // platform: FACEBOOK
    },
    {
      metrics: [METRIC_FACEBOOK_PAGE_FANS],
      title: 'followers',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      platform: FACEBOOK,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_FOLLWERS
        }
      }
    },
    {
      metrics: [33, 108],
      title: 'post_impressions',
      iconCssClass: icons.PLATFORM_ICONS[FACEBOOK],
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS
        }
      }
      // platform: FACEBOOK
    }
    // {
    //     metrics: [METRIC_FACEBOOK_PAGE_TOTAL_PAGE_VIEWS],
    //     title: 'page_visits',
    //     iconCssClass: 'optional value',
    //     hexColor: ANALYTICS_COLOR_3,
    //     type: 'line',
    //     platform: FACEBOOK,
    //     formula: 'delta',
    //     display: 'max',
    // }
  ]
};

export const clicksConfig = {
  filters: [],
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     platform: FACEBOOK,
  //     type: 'bar',
  // },
  metrics: [
    // {
    //     metrics: [METRIC_FACEBOOK_PAGE_CTA_CLICKS_LOGGED_IN_TOTAL],
    //     title: 'call_to_action',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_BLUE,
    //     platform: FACEBOOK,
    //     type: 'line'
    // },

    {
      metrics: [METRIC_FACEBOOK_PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE],
      title: 'website_button',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      platform: FACEBOOK,
      type: 'line'
    },
    {
      metrics: [METRIC_FACEBOOK_PAGE_IMPRESSIONS],
      title: 'page_impressions',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_3,
      platform: FACEBOOK,
      type: 'line'
    }
  ]
};

const interactionsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar',
  //     platform: FACEBOOK
  // },

  metrics: [
    {
      metrics: [71, 72, 73, 74, 75, 76, 120, 121, 122, 123, 124, 125],
      title: 'reactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_ENGAGEMENET_REATIONS
        }
      }
    },
    {
      metrics: [127],
      title: 'comments',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [0, 3, 5, 5, 7, 8, 8, 23]
        }
      }
    },
    {
      metrics: [126],
      title: 'shared',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [0, 2, 4, 4, 5, 7, 8, 13]
        }
      }
    }
    // {
    //     metrics: [METRIC_FACEBOOK_IMAGE_POST_CLICKS],
    //     title: 'clicks',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_PINK_BLUSH,
    //     type: 'line',
    //     platform: FACEBOOK
    // }
  ]
};

const overviewConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'Posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_LIKE_TOTAL,
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_LOVE_TOTAL,
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_WOW_TOTAL,
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_HAHA_TOTAL,
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_SORRY_TOTAL,
        METRIC_FACEBOOK_VIDEO_POST_REACTIONS_ANGER_TOTAL,
        METRIC_FACEBOOK_IMAGE_POST_COMMENT_COUNT,
        METRIC_FACEBOOK_IMAGE_POST_SHARES
      ],
      title: 'interactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_OVERVIEW_INTERACTION
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS],
      title: 'impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_OVERVIEW_IMPRESSION
        }
      }
    },
    {
      metrics: [
        METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_UNIQUE,
        METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_UNIQUE
      ],
      title: 'reach',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_OVERVIEW_REACH
        }
      }
    }
  ]
};

export const postsConfig = {
  overview: overviewConfig,
  engagement: interactionsConfig
};

export const facebookPostsViewsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [
        METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS,
        METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS
      ],
      title: 'impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS],
      title: 'post_impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_POST_IMPRESSIONS
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS],
      title: 'video_impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_VIDEO_IMPRESSIONS
        }
      }
    }
  ]
};

export const facebookPostsImpressionsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [
        METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_PAID,
        METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_ORGANIC
      ],
      title: 'impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_PAID],
      title: 'paid',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_ORGANIC],
      title: 'organic',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_GROWTH_IMPRESSIONS
        }
      }
    }
    // {
    //     metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_TOTAL_IMPRESSIONS_ORGANIC, METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_ORGANIC],
    //     title: 'organic',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_PINK,
    //     type: 'line'
    // },
    // {
    //     metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_PAID, METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_PAID],
    //     title: 'paid',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_PINK,
    //     type: 'line'
    // }
  ]
};

export const facebookVideoPostsImpressionsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //     title: 'posts',
  //     iconCssClass: 'fas fab-facebook',
  //     hexColor: ANALYTICS_COLOR_YELLOW,
  //     type: 'bar'
  // },

  metrics: [
    {
      metrics: [
        METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_PAID,
        METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_TOTAL_IMPRESSIONS_ORGANIC
      ],
      title: 'impressions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_VIDEO_IMPRESSIONS
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_PAID],
      title: 'paid',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      }
    },
    {
      metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_TOTAL_IMPRESSIONS_ORGANIC],
      title: 'organic',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_3,
      type: 'bar',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_VIDEO_IMPRESSIONS
        }
      }
    }
    // {
    //     metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_TOTAL_IMPRESSIONS_ORGANIC, METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_ORGANIC],
    //     title: 'organic',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_PINK,
    //     type: 'line'
    // },
    // {
    //     metrics: [METRIC_FACEBOOK_VIDEO_TOTAL_VIDEO_VIEW_TOTAL_IMPRESSIONS_PAID, METRIC_FACEBOOK_IMAGE_POST_IMPRESSIONS_PAID],
    //     title: 'paid',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_PINK,
    //     type: 'line'
    // }
  ]
};

// ------------------------------------------------------------------------------------------------------
export const growth = {
  addAdditionalPlots: true,

  reactions: {
    title: 'mixedChart.reactions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  followers: {
    title: 'mixedChart.followers',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.lastValue
  },
  impressions: {
    title: 'mixedChart.impressions',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',

    display: displayFunctions.sum
  },
  page_visits: {
    title: 'mixedChart.page_visits',
    hexColor: ANALYTICS_COLOR_4,
    type: 'line',

    display: displayFunctions.sum
  }
};
export const reachAndImpressions = {
  addAdditionalPlots: true,

  reach: {
    title: 'mixedChart.reach',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  impressions: {
    title: 'mixedChart.impressions',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const followerDetails = {
  addAdditionalPlots: true,

  followers: {
    title: 'mixedChart.followers',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.lastValue
  },
  fans: {
    title: 'mixedChart.fans',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.lastValue
  }
};
export const followerDevelopment = {
  addAdditionalPlots: true,
  gained: {
    title: 'mixedChart.gained',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  lost: {
    title: 'mixedChart.lost',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  }
};
export const clicksOnPage = {
  addAdditionalPlots: true,
  call_to_action: {
    title: 'mixedChart.call_to_action',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  website_button: {
    title: 'mixedChart.website_button',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  },
  page_visits: {
    title: 'mixedChart.page_visits',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',

    display: displayFunctions.sum
  }
};
export const newConfigsMap: any = {
  growth,
  reach_and_impressions: reachAndImpressions,
  follower_details: followerDetails,
  follower_development: followerDevelopment,
  clicks_on_page: clicksOnPage,
  posts_per_day: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
  },
  posts_per_day_plot: {
    posts_per_day_plot: {
      title: 'mixedChart.posts_per_day_plot',
      hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
    },
  }
};
